import * as React from 'react';

const BusinessSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="business_svg__eds-icon--business_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="business_svg__eds-icon--business_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M4 17h16V4H4v13zm7.5-15v1H3v14H2v1h8.3L7 21.3l.7.7 3.8-3.8V22h1v-3.8l3.8 3.8.7-.7-3.3-3.3H22v-1h-1V3h-8.5V2h-1z"
        />
        <g
            className="business_svg__eds-icon--business_lines"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
        >
            <path d="M16 9h1v4h-1zM14 7h1v6h-1zM12 9h1v4h-1z" />
        </g>
        <path
            className="business_svg__eds-icon--business_circle"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M8 9c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 3c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
        />
    </svg>
);

BusinessSvg.displayName = 'BusinessSvg';
export default BusinessSvg;
